import TradeInAemDebugModal from "./TradeInAemDebugModal";
import { aemToyotaCommonModalMap } from "../../../../common-deprecated/components/modals/aem/modals";
import { MODAL_TRADE_IN_AEM_DEBUG, type TradeInAemModalIdsType } from "../../../utils/modalConstants";
import type { ModalMapType } from "../../../../common-deprecated/types/CommonTypes";

export const aemToyotaTradeInModalMap: ModalMapType<TradeInAemModalIdsType> = {
    ...aemToyotaCommonModalMap,
    [MODAL_TRADE_IN_AEM_DEBUG]: TradeInAemDebugModal,
};
